
export const getBaseUrl =  'https://social-media-app-mern-stack-server.vercel.app'